const PageHeading = ({ title }) => {
  return (
    <div className="head-title list-page-heading">
      <div className="container">
        <div className="title-sec">
          <h1 className="title-25">{title}</h1>
        </div>
      </div>
    </div>
  );
};

export default PageHeading;
